module.exports = __webpack_public_path__ + "img/wj_tb_sp.0209567e.png";